<template>
  <div class="mask" @click="close()" v-show="visible">
    <div class="options-box">
      <div class="options-item" @click="handleClickItem(item,index)" v-for="(item,index) in options"
           :key="`options-item_${index}`">
<!--        <img class="icon" :src="item.icon"/>-->
        <div class="name">{{ item.name }}</div>
      </div>
      <div class="options-item" @click="close()">取消</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "index",
  props: {
    options: {
      type: Array,
      default: () => []
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClickItem(item, index) {
      this.$emit("click", {item, index})
    },
    close() {
      this.$emit("close");
    }
  },
}
</script>
<style scoped lang="scss">
@import "@/assets/sass/state.scss";

.mask {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  top: 0;
  z-index: 99;

  .options-box {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;

    .options-item {
      background-color: white;
      color: #3D3D3D;
      width: calc(100% - ($divPadding * 2));
      margin: 0 $divPadding;
      margin-bottom: 0.3267rem;
      padding: 0.3rem 0;
      border-radius: 0.1621rem;
      text-align: center;
      position: relative;

      .icon {
        position: absolute;
        left: 3.6rem;
        top: 0;
        bottom: 0;
        margin: auto 0;
        width: auto;
        height: auto;
        max-width: 0.5405rem;
        max-height: 0.5405rem;
      }
    }
  }

}
</style>